import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import Ticker from "@/components/Ticker";
import About from "@/components/About";
import RulesGlance from "@/components/RulesGlance";
import ChallengeMatrix from "@/components/ChallengeMatrix";
import ConsistencyCalculator from "@/components/ConsistencyCalculator";
import DiscordSpotlight from "@/components/DiscordSpotlight";
import ScalingPlan from "@/components/ScalingPlan";
import EditorialMarquee from "@/components/EditorialMarquee";
import FAQ from "@/components/FAQ";
import Seo from "@/components/Seo";

export default function Home() {
  return (
    <main>
      <Seo
        title="MyFXPocket — Prop Trading Firm | Trade Easy. No Bull."
        description="Get funded up to $400,000 with MyFXPocket. Forex evaluation challenges and instant funding, 80/20 profit split, payouts every 5–14 days, free mentorship."
        path="/"
      />
      <Hero />
      <Ticker />
      <About />
      <RulesGlance />
      <ChallengeMatrix />
      <ConsistencyCalculator />
      <DiscordSpotlight />
      <ScalingPlan />
      <EditorialMarquee />
      <FAQ />
    </main>
  );
}
